import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import App from "./components/App.vue";
import AuthView from "./components/AuthView.vue";
import "./registerServiceWorker";
import firebase from "firebase/app";
import "firebase/auth";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import "@/plugins/vuefire";
import "@/plugins/ioc";

Vue.config.productionTip = false;

enum AuthStatus {
  Unauthenticated,
  Unauthorized,
  Authorized
}

async function getAuthStatus(user: firebase.User | null): Promise<AuthStatus> {
  if (!user) {
    return AuthStatus.Unauthenticated;
  }
  try {
    const u = await firebase
      .firestore()
      .doc(`/users/${user?.uid}`)
      .get();

    if (!u.exists) {
      return AuthStatus.Unauthorized;
    } else {
      return AuthStatus.Authorized;
    }
  } catch (e) {
    return AuthStatus.Unauthorized;
  }
}

firebase.auth().onAuthStateChanged(user => {
  getAuthStatus(user).then(authStatus => {
    switch (authStatus) {
      case AuthStatus.Unauthenticated:
        (window as any).vue = new Vue({
          el: "#app",
          render: h => h(AuthView)
        });
        break;
      case AuthStatus.Unauthorized:
        console.log(`unauthorized ${user?.uid}`);
        break;
      case AuthStatus.Authorized:
        (window as any).vue = new Vue({
          router,
          vuetify,
          created() {
            if (user && this.$router.currentRoute.path == "/auth") {
              this.$router.push("/");
            } else if (!user && this.$router.currentRoute.path != "/auth") {
              this.$router.push("/auth");
            }
          },
          el: "#app",
          render: h => h(App)
        });
        break;
    }
  });
});
